// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qdRa","label":"styles_label__2EMEc"};